import './MediaLibraryCard.scss';
import { usePersistentImage } from '../../hook/usePersistentImage';

interface MediaImage {
  name: string;
  url: string;
  last_modified: string;
}

interface MediaLibraryCardProps {
  mediaImage: MediaImage;
}

export const MediaLibraryCard: React.FC<MediaLibraryCardProps> = ({ mediaImage }) => {
  const { imageUrl, loading, error } = usePersistentImage({
    url: mediaImage.url,
    lastModified: mediaImage.last_modified
  });

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const renderImage = () => {
    if (loading) {
      return <div className="media-library-card__loading">Loading...</div>;
    }
    
    if (error) {
      return (
        <div className="media-library-card__error">
          <div className="media-library-card__error-message">Failed to load image</div>
        </div>
      );
    }
    
    return (
      <img 
        src={imageUrl || mediaImage.url} 
        alt={mediaImage.name}
        onError={() => {
          console.error('Image failed to load:', mediaImage.url);
        }}
      />
    );
  };

  return (
    <div className="media-library-card">
      <div className="media-library-card__image">
        {renderImage()}
      </div>
      <div className="media-library-card__wrapper">
        <div className="media-library-card__info">
          <div className="media-library-card__name">
            <span>{mediaImage.name}</span>
          </div>
        </div>
        <div className="media-library-card__metadata">
          <span className="media-library-card__date">Modified: {formatDate(mediaImage.last_modified)}</span>
        </div>
      </div>
    </div>
  );
}; 